import { Box, useTheme } from '@mui/material';
import { type SxProps } from '@mui/system';
import {
  type FC,
  type MutableRefObject,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { BaseSelect } from '../BaseSelect';

type Props = {
  title?: string;
  onChange?: (value: string) => void;
  value?: string;
  sx?: SxProps;
  type?: string;
  valueForNumberChanging?: number;
  inputRef?: MutableRefObject<HTMLInputElement>;
  items: { value: string; label: string }[];
  noSelectLabel?: string;
  translate?: boolean;
  error?: boolean;
  disabled?: boolean;
  updated?: boolean;
  helperText?: string;
  fullWidth?: boolean;
};
export const MobileSelect: FC<Props> = ({
  sx = {},
  value,
  onChange,
  noSelectLabel,
  items,
  translate,
  title,
  error,
  disabled,
  updated,
  helperText,
  fullWidth,
  ...props
}) => {
  const theme = useTheme();
  const selectRef = useRef<HTMLDivElement>(null);
  const [popoverWidth, setPopoverWidth] = useState<number>(200);

  const styles = useMemo(
    () => ({
      container: {
        borderRadius: theme.shape.borderRadius,
        width: '100%',
        minWidth: '100%',
        ...sx,
      },
      button: {
        borderRadius: theme.shape.borderRadius,
        height: theme.spacing(5), // 40px
        borderColor: error
          ? theme.palette.error.main
          : updated
            ? theme.palette.success.main
            : theme.palette.divider,
      },
      label: {
        color: theme.palette.text.primary,
      },
    }),
    [theme, error, updated, sx]
  );
  useEffect(() => {
    const updatePopoverWidth = () => {
      if (selectRef.current) {
        setPopoverWidth(selectRef.current.offsetWidth);
      }
    };

    updatePopoverWidth();

    window.addEventListener('resize', updatePopoverWidth);
    return () => {
      window.removeEventListener('resize', updatePopoverWidth);
    };
  }, []);
  return (
    <Box ref={selectRef} sx={{ width: fullWidth ? '100%' : 'auto' }}>
      <BaseSelect
        sx={styles.container}
        sxBtn={styles.button}
        sxLabel={styles.label}
        error={error}
        title={title}
        value={value}
        onChange={onChange}
        items={items}
        hideAllButton
        noSelectLabel={noSelectLabel}
        hideValue
        formInput
        withoutMargin
        translate={translate}
        popoverMinWidth={`${popoverWidth}px`}
        disabled={disabled}
        helperText={helperText}
        {...props}
      />
    </Box>
  );
};
